import { useState, useEffect } from "react";
import { createUseStyles } from "react-jss";

import { templateService } from "services";
import { TemplateCommon, TemplateDto, TemplateRequestDto } from "dtos/shard/template.dto";
import { UserDto } from "dtos/user.dto";

import widgets from "styles/widgets";
import { useResources } from "hooks/resources.hook";
import { useEditorActions } from "hooks/editor-actions.hook";
import { useEditorPreview } from "hooks/editor-preview.hook";
import EditorControls from "../editor-controls";

const styles = createUseStyles({
    container: {
        width: "100%",
    },
});

export default function TemplateEditor(props: {
    user?: UserDto, // Optional dto of the user.
    template?: Partial<TemplateDto>,
    preview?: Partial<TemplateDto>,
    onPreviewUpdate?: (previewDto: Partial<TemplateDto>) => void,
    onClose?: () => void,
    onSave?:(template: TemplateDto) => void,
}): JSX.Element
{
    // Dtos:
    const freshCommon: TemplateCommon = {
        name: props.template?.name ?? "",
    };
    const freshRequestDto: TemplateRequestDto = {
        id: props.template?.id,
        ...freshCommon,
    };
    const freshPreviewDto: Partial<TemplateDto> = props.preview ? structuredClone(props.preview) : props.template ? structuredClone(props.template) : {
        id: undefined,
        ...freshCommon,
    };

    // Hooks:
    const resources = useResources(props.user);
    const [previewDto, requestDto, previewUpdate, setRequestDto] = useEditorPreview(freshPreviewDto, freshRequestDto, props.onPreviewUpdate);
    const [onTextChange, onNumberChange, onRteChange, onCheckboxChange, onPopup] = useEditorActions(props.user, "template", resources, requestDto, previewDto, setRequestDto, props.onPreviewUpdate);

    // Effects:
    useEffect(() => {
        setRequestDto(freshRequestDto);
    }, [props.template]);

    // Styles:
    const widgetClasses = widgets();
    const classes = styles();

    // Templates:
    const reset = () => {
        setRequestDto(freshRequestDto);
        if (props.onPreviewUpdate) {
            props.onPreviewUpdate(props.template ?? previewDto);
        }
    };
    
    // Return Component:
    return (
        <div className={`${widgetClasses.form} ${classes.container}`}>
            <div className={`${widgetClasses.row}`}>
                <label>Name</label>
                <input id="name" type="text" value={requestDto.name ?? ""} onChange={onTextChange} />
            </div>

            <hr/>
            <EditorControls
                editorName="template"
                service={templateService}
                subject={props.template}
                subjectName={props.template?.name ?? ""}
                requestDto={requestDto}
                onSave={props.onSave}
                onReset={reset}
                onClose={props.onClose}
            />
            <hr/>
        </div>
    );
}